import { request } from '../methods'

export default {
  create: request('post', '/api/v1/tasks/'),
  read: request('get', '/api/v1/tasks/{id}/'),
  update: request('put', '/api/v1/tasks/{id}/'),
  patch: request('patch', '/api/v1/tasks/{id}/'),
  delete: request('delete', '/api/v1/tasks/{id}/'),
}
